/**
 * WHO IS WAITING FOR OUR REPLY (redesign register D2; brief FE-FOUNDATION section 12).
 *
 * One rule every page uses: an agency is waiting when `unanswered_since` is set and
 * `reply_handled_at` is empty or earlier than `unanswered_since`. A person's "Mark as handled"
 * stamps the time; a new client message moves `unanswered_since` past it and the client is
 * waiting again without anybody clearing anything (D2). Compared as instants, because both
 * are DATETIME values written by different clocks' formats (the feed and the server).
 */
function instant(value: string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const time = Date.parse(value);
  return Number.isNaN(time) ? null : time;
}

export function isWaitingForReply(
  unansweredSince: string | null | undefined,
  replyHandledAt: string | null | undefined,
): boolean {
  const since = instant(unansweredSince);
  if (since === null) return false;
  const handled = instant(replyHandledAt);
  return handled === null || handled < since;
}
